/** A status, said in words with an icon - **never by colour alone** (F-040, design rule 4).
 *
 * **This is `ui/StatusChip`** (design uplift U4). The product had two near-identical chips, differing by
 * a pixel of padding and a font weight, and the audit counted that as the first reason the same status
 * reads differently on two pages. `StatusPill` stays as a name so its importers did not have to change
 * in the same commit; it renders the one chip, and a new use should import `StatusChip` directly.
 *
 * The tone picks the icon as well as the tint, so a reader who cannot tell the amber from the red
 * still gets a different shape and a label. The label is required and is the chip's accessible name;
 * the icon is decoration. It states a fact and is not a control. For something pressable use a button.
 */

import type { ReactNode } from "react";

import type { ChipTone } from "./ui/StatusChip";
import { StatusChip } from "./ui/StatusChip";

export type StatusTone = ChipTone;

export function StatusPill({
  tone,
  children,
  testId,
}: {
  tone: StatusTone;
  /** The words. Required: a pill with only a colour is the defect this exists to prevent. */
  children: ReactNode;
  testId?: string;
}) {
  return (
    <StatusChip tone={tone} {...(testId !== undefined ? { testId } : {})}>
      {children}
    </StatusChip>
  );
}
